import React from 'react';
import {
  Component, Container, HBox, PuzzleButton, VBox,
} from 'puzzle';
import Favorites from "./Favorites/Favorites";
import { setDocumentTitle } from "../util/Util";
import { MAIN_GRID_ITEM } from "./Types";
import { PREFERENCES_DATA } from "../Preferences/Types";
import Widgets from "./Widgets/Widgets";

type PROPS = {
  actionsNames: {
    filter: string,
    refreshGrid: string,
    refreshGridOnCurrentPosition: string
  },
  initializeUserData: any,
  title: string
}

type STATE = {
  userName: string
  preferencesData: PREFERENCES_DATA
}

class Dashboard extends Component<PROPS, STATE> {
  static defaultProps = {
    actionsNames: {
      filter: 'filterMainGrid',
      refreshGrid: 'refreshMainGridWhenDrawerIsNotOpen',
      refreshGridOnCurrentPosition: 'refreshAppAndFilters'
    }
  }

  state = {
    userName: this.translate('guestUserName'),
    preferencesData: {
      autoRefresh: false,
      drawerOption: false,
      city: '',
      country: '',
      dueSoon: 0,
      dueSoonDurations: [],
      keyboardShortcuts: false,
      language: { locale: '', value: '' },
      mailNotificationsEnabled: false,
      notifications: [],
      sendEmailJustForMySubmissions: false,
      theme: '',
      viewType: 'COMFORTABLE'
    }
  };

  /**
   * @inheritDoc
   */
  moduleDidMount = () => {
    setDocumentTitle(this.props.title);
  };

  /**
   * Refresh Button click handler, refreshes main grid on current scroll position
   */
  handleRefreshGrid = (ev: React.MouseEvent) => {
    this.dispatch(this.props.actionsNames.refreshGridOnCurrentPosition);
  }

  /**
   * Sets `state`s `userName` value.
   *
   * @param {String} userName
   */
  setUserName = (userName: string) => {
    this.setState({ userName });
  };

  /**
   * Sets `state`s `userName` value.
   *
   * @param {PREFERENCES_DATA} preferencesData
   */
  setPreferenceData = (preferencesData: PREFERENCES_DATA) => {
    this.setState({ preferencesData });
  };

  shouldComponentUpdate(props: any, state: any) {
    return state.userName !== this.translate('guestUserName');
  }

  /**
   * Puts data in proper format for sending it as MainGrid filter data
   * @param submission
   */
  prepareFilterData = (submission: MAIN_GRID_ITEM) => {
    const { submissionName: submissionNameInputText, submissionId } = submission;

    return JSON.stringify({
      submissionNameInputText,
      submissionId
    });
  };

  /**
   * Refresh button render
   */
  renderRefreshButton(): JSX.Element {
    return <PuzzleButton
      aria-label={this.translate('SRL-refreshDashboard')}
      titleText={this.translate('SRL-refreshDashboard')}
      themeColor={'primary'}
      fillMode="outline"
      className="tp-with-bg"
      iconClass="tp-icon tp-refresh"
      onClick={this.handleRefreshGrid}
      tooltipPosition={'left'}
      withTooltip
    />
  }

  renderBody() {
    const { initializeUserData } = this.props;
    const { userProfile } = initializeUserData;
    return (
      <Container vBox className='tp-page tp-dashboard-page' gap={4}>
       <HBox alignItemsBaseLine justifyContentBetween className={'tp-page-title-wrapper'}>
         <h2 className={'tp-page-title'}>
           {this.translate('pageHeadline', {userName: userProfile.userInfo.firstName})}
         </h2>
         {this.renderRefreshButton()}
       </HBox>
        <VBox className={'tp-dashboard-scrollable-content'} flex1 gap={4}>
          <Widgets
            dueSoonRange={initializeUserData?.preferences?.dueSoon}
            quickLinks={initializeUserData.quickLinks}
          />
          <Favorites
            initializeUserData={initializeUserData}
            preferencesData={this.state.preferencesData}
            actionsNames={this.props.actionsNames}
          />
        </VBox>
      </Container>
    );
  };


}

export default Dashboard;
